<template>
	<div>
		<Header />

		<div class="ifram">
			<iframe id="iframe" ref="dynamicIframe" :src="url" width="100%" frameborder="0"></iframe>

		</div>


		<Footer />
	</div>
</template>

<script>
	import Header from '@/common/header'
	import Footer from '@/common/footer.vue'
	import publicMethod from '@/views/publicMethod'


	export default {
		mixins: [publicMethod],
		components: {
			Header,
			Footer

		},
		data() {
			return {
				url: '',
				resources: [{
						type: 'css',
						href: 'stockBp/libs/css/myAlert.min.css'
					},
					{
						type: 'css',
						href: 'stockBp/css/common.css'
					},
					{
						type: 'js',
						src: 'stockBp/libs/js/myAlert.min.js'
					},
					{
						type: 'js',
						src: 'stockBp/js/common.js'
					},
					{
						type: 'js',
						src: 'stockBp/js/iframe.js'
					}
				]

			}
		},
		mounted() {
			const now = new Date();

			this.url = this.domain.testUrl + 'stockBp/bpList.html?id=' + window.channelId + '&v=' + now.getTime() + (
				localStorage.userToken ? '&userToken=' + localStorage.userToken : '')

			// this.url = 'http://127.0.0.1:5500/bpList.html?id=' + window.channelId + (localStorage.userToken ? '&userToken=' +
			// 	localStorage.userToken : '')


			this.loadResources()

			sessionStorage.url = this.domain.partyDomain
			sessionStorage.bpListUrl = this.domain.partyDomain + '#/bpList' //设置bp列表地址

			sessionStorage.channel = window.channelId
			sessionStorage.securityCode = window.channel


		},
		beforeDestroy() {
			window.location.reload();
		},
		methods: {


		}
	}
</script>

<style>
</style>